import { render, staticRenderFns } from "./FlashcardsConfig.vue?vue&type=template&id=22cbc90a&scoped=true&"
import script from "./FlashcardsConfig.vue?vue&type=script&lang=js&"
export * from "./FlashcardsConfig.vue?vue&type=script&lang=js&"
import style0 from "./FlashcardsConfig.vue?vue&type=style&index=0&id=22cbc90a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cbc90a",
  null
  
)

export default component.exports